var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M1 12.5H5C5.13261 12.5 5.25975 12.5527 5.35352 12.6465C5.44728 12.7403 5.5 12.8674 5.5 13V21C5.5 21.1326 5.44728 21.2597 5.35352 21.3535C5.25975 21.4473 5.13261 21.5 5 21.5H1C0.867391 21.5 0.740252 21.4473 0.646484 21.3535C0.552717 21.2597 0.5 21.1326 0.5 21V13L0.509766 12.9023C0.528936 12.8061 0.576081 12.7169 0.646484 12.6465C0.740253 12.5527 0.867392 12.5 1 12.5Z",
    fill: "black",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 0.5H13C13.1326 0.5 13.2597 0.552716 13.3535 0.646484C13.4473 0.740253 13.5 0.867392 13.5 1V21C13.5 21.1326 13.4473 21.2597 13.3535 21.3535C13.2597 21.4473 13.1326 21.5 13 21.5H9C8.86739 21.5 8.74025 21.4473 8.64648 21.3535C8.55272 21.2597 8.5 21.1326 8.5 21V1C8.5 0.867392 8.55272 0.740253 8.64648 0.646484C8.74025 0.552716 8.86739 0.5 9 0.5Z",
    fill: "black",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17 8.5H21C21.1326 8.5 21.2597 8.55272 21.3535 8.64648C21.4473 8.74025 21.5 8.86739 21.5 9V21C21.5 21.1326 21.4473 21.2597 21.3535 21.3535C21.2597 21.4473 21.1326 21.5 21 21.5H17C16.8674 21.5 16.7403 21.4473 16.6465 21.3535C16.5527 21.2597 16.5 21.1326 16.5 21V9C16.5 8.86739 16.5527 8.74025 16.6465 8.64648C16.7403 8.55272 16.8674 8.5 17 8.5Z",
    fill: "black",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter_icon.5de2d51dae39ee8ce584bffb9be345f6.svg";
export { ForwardRef as ReactComponent };